import React, { useEffect, useState } from "react";

import "./CurrencyEnabler.scss";
import { Checkbox, CircularProgress } from "@material-ui/core";

const CurrencyEnabler = (props: {
  index?: number;
  currency?: any;
  onCheck?: (checked: boolean) => void;
  onRowSelect?: (currency: any) => void;
  currentRow?: any;
}) => {
  const [busy, setBusy] = useState<boolean>(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | undefined>(
    undefined
  );
  const [currentRow, setCurrentRow] = useState<any>("");
  useEffect(() => {
    setBusy(false);
  }, [props.currency]);

  useEffect(() => {
    setCurrentRow(props.currentRow);
  }, [props.currentRow]);

  if (!props.currency) {
    return null;
  }

  function handleRowClick() {
    props.onRowSelect && props.onRowSelect(props.currency.id);
    setSelectedRowIndex(props.index);
  }

  const isChecked = props.currency.enabled === true;
  return (
    <tr
      className={`${
        props.index === selectedRowIndex && currentRow === props.currency.code
          ? "CurrencyEnabler-selected"
          : "CurrencyEnabler-notSelected"
      } CurrencyEnabler-row`}
      onClick={handleRowClick}
    >
      <td>
        {busy ? (
          <CircularProgress className="CurrencyEnabler-busy" />
        ) : (
          <Checkbox
            className="CurrencyEnabler-enabled"
            checked={isChecked}
            disabled={busy}
            onChange={async () => {
              if (props.onCheck) {
                try {
                  setBusy(true);
                  await props.onCheck(!isChecked);
                } catch (e) {
                  setBusy(false);
                  throw e;
                }
              }
            }}
          />
        )}
      </td>
      <td className="CurrencyEnabler-code">{props.currency.code}</td>
      <td className="CurrencyEnabler-name">
        {props.currency.region} - {props.currency.name}
      </td>
    </tr>
  );
};

export default CurrencyEnabler;
